import { update } from "lodash";
import axiosInstance from "./api_helper";

const expenseService = {
    
    list: async ({ categoryId, commercialId, dateFrom, dateTo, query }) => {
        return axiosInstance.get(`/api/expenses`, {
            params: {
                categoryId,
                commercialId,
                dateFrom,
                dateTo,
                query
            }
        });
    },
    create: async (payload) => {
        return await axiosInstance.post('/api/expenses', payload);
    },
    update: async (payload) => {
        console.log("Updating expense with payload:", payload);
        return axiosInstance.put(`/api/expenses/${payload.id}`, JSON.stringify(payload));
    },
    delete: async (id) => {
        return axiosInstance.delete(`/api/expenses/${id}`);
    },

    listCategories: async () => {
        return axiosInstance.get(`/api/expenses/category`);
    },

    createCategory: async ({ libelle }) => {
        return await axiosInstance.post(`/api/expenses/category?libelle=${encodeURIComponent(libelle)}`);
    },

    updateCategory: async (payload) => {
        return await axiosInstance.put(`/api/expenses/category/${payload.id}`, payload.data);
    },

    deleteCategory: async (id) => {
        return await axiosInstance.delete(`/api/expenses/category/${id}`);
    }

};

export default expenseService;